
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.605","height":"22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.139 21.975l-.152-.05q-.051-.025-.57-.342t-1.353-.872q-.834-.556-1.884-1.34a25.832 25.832 0 01-2.136-1.8 23.526 23.526 0 01-2.339-2.365 21.6 21.6 0 01-1.786-2.388A13.02 13.02 0 01.477 9.783a9.914 9.914 0 01-.481-3.009 6.606 6.606 0 01.532-2.63 6.8 6.8 0 011.454-2.162A6.819 6.819 0 014.144.528a6.662 6.662 0 012.655-.531 5.854 5.854 0 011.922.341 6.938 6.938 0 011.871 1 8.819 8.819 0 01.948.822 5.413 5.413 0 01.746.923 6.474 6.474 0 01.772-.923 8.674 8.674 0 01.948-.822 6.993 6.993 0 011.858-1 5.809 5.809 0 011.935-.341 6.577 6.577 0 012.643.531 6.874 6.874 0 012.149 1.454 7.019 7.019 0 011.467 2.162 6.474 6.474 0 01.544 2.63 9.938 9.938 0 01-.481 3.009 13.081 13.081 0 01-1.438 3.035 20.836 20.836 0 01-1.8 2.389 26.57 26.57 0 01-2.327 2.365q-1.113 1.012-2.162 1.8t-1.871 1.34q-.821.556-1.34.872t-.569.342l-.152.05a.541.541 0 01-.177.025.458.458 0 01-.146-.026z","fill":"#007aff"}})])
          )
        }
      }
    